import React from "react"
import {withRouter, Link } from 'react-router-dom'
import {Card, Col, Row, Spin, Typography} from "antd"
import Chart from "react-apexcharts";
import BaseDocumentControl from "./BaseDocumentControl"
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"

const { Text } = Typography;

class DashboardDocumentControl extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loadingDocument: false,
            options: {
                chart: {
                  id: "basic-bar"
                },
                xaxis: {
                  categories: ["Enero", "Febrero", "Marzo", "Abril", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
                }
              },
            series: [
                {
                  name: "series-1",
                  data: [5000, 8000, 7000, 10000, 13000, 14000, 13000, 16000]
                }
            ],

            optionsDonut: {
                series: [44, 55, 41, 17, 15],
                labels: ['Santiago', 'Concepción', 'Valparaiso', 'Puerto Montt', 'Otras']
            },
            seriesDonut: [44, 55, 41, 17, 15],
        }
    }

    componentDidMount = async () => {
    }

    render() {
        if (this.state.loading ){
            return (
                <BaseDocumentControl selected='document-control'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseDocumentControl>
            )
        } else {

            return (
                <BaseDocumentControl
                    selected="document-control">

                        <Row gutter={[8, 12]} type="flex">
                            <Col lg={6}>
                                <Card
                                    title="Candidatos"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%' }}>
                                    <Text strong style={{ fontSize: '20px', fontWeight: "" }}>15213</Text>
                                </Card>
                            </Col>
                                <Col lg={6}>
                                <Card
                                    title="Candidatos validados"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%'   }}>
                                    <Text strong style={{ fontSize: '20px', fontWeight: "" }}>11512</Text>
                                </Card>
                            </Col>
                            <Col lg={6}>
                                <Card
                                    title="Conversión"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%'  }}>
                                    <Text strong style={{ fontSize: '20px', fontWeight: "" }}>75,6%</Text>
                                </Card>
                            </Col>
                            <Col lg={6}>
                                <Card
                                    title="Tasa de rechazo"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%'  }}>
                                        <Text strong style={{ fontSize: '20px', fontWeight: "" }}>5%</Text>
                                </Card>
                            </Col>
                        </Row>

                        <Row gutter={[8, 12]} type="flex">
                            <Col lg={12} xs={24}>
                                <Card
                                    title="Candidatos validados entrenados"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%'  }}>
                                        <Text strong style={{ fontSize: '20px', fontWeight: "" }}>9200</Text>
                                </Card>
                            </Col>
                            <Col lg={12} xs={24}>
                                <Card
                                    title="Candidatos validados entrenados"
                                    bodystyle={{ width: '100%', textAlign: 'center', height: '100%'  }}>
                                        <Text strong style={{ fontSize: '20px', fontWeight: "" }}>79,9 %</Text>
                                </Card>
                            </Col>
                        </Row>

                        <Row gutter={[8, 12]} type="flex" style={{ marginTop: '6px' }}>
                            <Col lg={16} xs={12}>
                                <Card
                                    xs={12}
                                    title={"Evolución de candidatos por mes (Últimos 12 meses)"}
                                    bodystyle={{ textAlign: 'center', height: '100%'  }}>
                                    {
                                        this.state.loading ?
                                            <Spin></Spin>
                                            :
                                            <Chart
                                                options={this.state.options}
                                                series={this.state.series}
                                                height='150px'
                                                width="90%"
                                            />
                                    }
                                </Card>
                            </Col>
                            <Col lg={8} xs={12}>
                                <Card
                                    xs={12}
                                    title={"Distribución por ciudad"}
                                    bodystyle={{ textAlign: 'center', height: '100%'  }}>
                                    {
                                        this.state.loading ?
                                            <Spin></Spin>
                                            :
                                            <Chart
                                                options={this.state.optionsDonut}
                                                series={this.state.seriesDonut}
                                                type="donut"
                                                height='150px'
                                                width="85%"
                                            />
                                    }
                                </Card>
                            </Col>
                        </Row>
                </BaseDocumentControl>
            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardDocumentControl));